
import { Flex, Center, Icon, Text} from "@chakra-ui/react"
import { Invalid } from "../icons/icons"



const InvalidInput = ({isError , label, override} : {isError : boolean, label ?: string, override ?: string}) => {

    if (override != null && override == "") return <></>

    return <>
    {isError && 
        <Flex pt="4px">
            <Center>
            <Icon ml="4px" mr="4px" w="16px" h="16px" viewBox="0 0 20 20" fill="white">
                <Invalid/>
            </Icon>
            </Center>
            <Center>
                <Text color="#FF4F28" fontSize="md">
                    {override ? override : 
                    `It looks like that isn't a valid ${label}`
                    }
                </Text>
            </Center>
            
        </Flex>
    }
    </>
}

export default InvalidInput